// src/AppPublic.js
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Header from "./Public/Header";
import BottomNav from "./Public/BottomNav";
import PrivacyPolicy from "./Public/PrivacyPolicy";
import Contact from "./Public/Contact";
import config from "./config.json";

const AppPublic = () => {
  const location = useLocation();
  const title = location.pathname.includes("privacypolicy")
    ? "Privacy Policy"
    : location.pathname.includes("contact")
    ? "Contact us"
    : config.apptitle;

  return (
    <div className="mobile-app-shell">
      <Header title={title} />
      <main className="container" style={{ paddingBottom: "24px" }}>
        <Routes>
          <Route path="privacypolicy" element={<PrivacyPolicy />} />
          <Route path="contact" element={<Contact />} />
        </Routes>
      </main>
      <BottomNav />
    </div>
  );
};

export default AppPublic;
